import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { SectionWrapper } from '../components/primitives/index.js'
import { useProducts } from '../context/ProductsContext.jsx'
import './FAQ.css'

const EASE = [0.16, 1, 0.3, 1]

function FaqRow({ item, open, onToggle }) {
  return (
    <div className="faq__row">
      <button type="button" className="faq__question" onClick={onToggle} aria-expanded={open}>
        <span>{item.q}</span>
        <motion.span
          className="faq__chevron"
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ duration: 0.25, ease: EASE }}
          aria-hidden="true"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: EASE }}
            style={{ overflow: 'hidden' }}
          >
            <p className="faq__answer">{item.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default function FAQ() {
  const { faqs } = useProducts()
  const [openIdx, setOpenIdx] = useState(-1)
  if (!faqs.length) return null

  return (
    <SectionWrapper id="faq" className="faq container">
      <div className="faq__grid">
        <div className="faq__header">
          <span className="faq__eyebrow">Research FAQ</span>
          <h2>Know the sequence.</h2>
          <p>Common questions about our research compounds, purity standards, handling, and legal use.</p>
        </div>

        <div className="faq__list">
          {faqs.map((item, idx) => (
            <FaqRow key={item.q} item={item} open={openIdx === idx} onToggle={() => setOpenIdx((v) => (v === idx ? -1 : idx))} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  )
}
